export default function placeGrid() {
  return {
    _id: false,
    type: 'droplet.placeGrid',
    mediaQueries: [],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
    hideFilters: false,
    customCategories: [],
    customList: false,
    paginate: 24,
    placeholder: 'Search...',
    sortKey: {
      label: 'Name',
      value: 'name',
    },
    map: false,
    sort: 'normal',
    match: 'all',
    filterText: 'Filters',
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/place-grid/droplet.schema.js